import React from 'react';
import { OrderList } from '@/components/admin/OrderList';

export const AdminOrders: React.FC = () => {
  return <OrderList />;
};
